export default {
  subjectAdditionalTitle: 'Autre :',
};
